// Holds the contextful message/notification/modal APIs from antd's <App> so
// they can be called from non-component code (sagas, fetch.js, class components)
// without the "Static function can not consume context" deprecation warning.
let messageApi = null
let notificationApi = null
let modalApi = null

export const setMessageApi = (next) => {
  messageApi = next
}
export const setNotificationApi = (next) => {
  notificationApi = next
}
export const setModalApi = (next) => {
  modalApi = next
}

const wrap = (getApi, method) => (...args) => {
  const api = getApi()
  if (api && api[method]) return api[method](...args)
}

export const message = {
  success: wrap(() => messageApi, "success"),
  error: wrap(() => messageApi, "error"),
  info: wrap(() => messageApi, "info"),
  warning: wrap(() => messageApi, "warning"),
  loading: wrap(() => messageApi, "loading"),
  open: wrap(() => messageApi, "open"),
  destroy: wrap(() => messageApi, "destroy"),
}

export const notification = {
  success: wrap(() => notificationApi, "success"),
  error: wrap(() => notificationApi, "error"),
  info: wrap(() => notificationApi, "info"),
  warning: wrap(() => notificationApi, "warning"),
  open: wrap(() => notificationApi, "open"),
  destroy: wrap(() => notificationApi, "destroy"),
}

export const modal = {
  confirm: wrap(() => modalApi, "confirm"),
  info: wrap(() => modalApi, "info"),
  success: wrap(() => modalApi, "success"),
  error: wrap(() => modalApi, "error"),
  warning: wrap(() => modalApi, "warning"),
}
